import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ProductrawEditFormImpl from './ProductrawEditFormImpl';
import ProductrawList from './ProductrawList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ProductrawListView from './ProductrawListView'


export default function ProductrawDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.productrawDashboard);
  const [ productrawId, setProductrawId] = React.useState('');
  const [reloadProductrawList, setReloadProductrawList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ProductrawEditFormImpl 
            setReloadProductrawList={setReloadProductrawList}
            productrawId={productrawId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ProductrawListView 
                      setProductrawId = {setProductrawId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
